export const ORIGIN_PM = 'Pmkino'
export const ORIGIN_DATA_PROVIDER = 'DataProvider'